import React from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import {useSelector} from 'react-redux';
import {APP_PREFIX_PATH, CUSTOMER_PREFIX_PATH, RESELLER_PREFIX_PATH, ADVERTISER_PREFIX_PATH} from 'configs/AppConfig'
import CheckPermissions from "../services/CheckPermissions";

const PublicRoute = () => {

    const {token} = useSelector(state => state.auth)
    if (token) {
        if (CheckPermissions('all_customer_permissions')) {
            return <Navigate to={`${CUSTOMER_PREFIX_PATH}/dashboard`}/>
        } else if (CheckPermissions('all_reseller_permissions')) {
            return <Navigate to={`${RESELLER_PREFIX_PATH}/dashboard`}/>
        } else if (CheckPermissions('all_advertiser_permissions')) {
            return <Navigate to={`${ADVERTISER_PREFIX_PATH}/dashboard`}/>
        } else {
            return <Navigate to={`${APP_PREFIX_PATH}/dashboard`}/>
        }
    } else {
        return <Outlet/>
    }
}

export default PublicRoute
